import {mutations} from './mutations';
import {actions} from './actions';
import {getters} from './getters';

const state = {
    tenants: [],
    tenantsExpire: null,
    tenantsLoading: false,
    tenantSaving: false,
    tenantFeatures: {},
    availableFeatures: []
};

export default {
    namespaced: true,

    state,
    getters,
    actions,
    mutations
}

